import { useSuspenseInfiniteQuery } from '@tanstack/react-query';

import { projectsInfiniteQueryOptions } from '../data-provider';
import type { ProjectsSearchParams } from '../models';

export const useSuspenseProjects = (filters: ProjectsSearchParams = {}) => {
  return useSuspenseInfiniteQuery(projectsInfiniteQueryOptions(filters));
};
